import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';

import { MatChipsModule } from '@angular/material/chips';
import { AvailabilityType } from '@features/booking';

/**
 * Booking Period Details Component
 *
 * Purpose: Displays booking period metadata (resource, date, time, price) in a
 * consistent vertical layout with optional booking request badge.
 *
 * Usage:
 * ```html
 * <app-booking-period-details [availabilityType]="bp.availabilityType">
 *   <app-icon-label icon="home" [text]="resourceName"></app-icon-label>
 *   <app-date-icon-label-variations [startDate]="date" [endDate]="date" />
 *   <app-icon-label icon="payment" [text]="price"></app-icon-label>
 * </app-booking-period-details>
 * ```
 */
@Component({
  selector: 'app-booking-period-details',
  imports: [MatChipsModule],
  templateUrl: './booking-period-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './booking-period-details.component.scss',
})
export class BookingPeriodDetails {
  availabilityType = input<AvailabilityType>(null);

  readonly isBookingRequest = computed(() => this.availabilityType() === 'REQUEST');
}
